require('../brokerMyInvestmentsFooter/brokerMyInvestmentsFooter.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const classNames = require('classnames');

// @helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
const { formatCurrency, formatWithoutRound } = require('utilities/currencyHelper');

const { getFirstNChars } = require('utilities/stringHelper');

// @constants
const { BROKER_CUSTOM_CONFIG_WALLET_GENERAL_NAME } = require('customWallets/constants/index');
const MAX_LENGHT_OF_CUSTOM_VIEW_NAME = 28;

class BrokerMyInvestmentsFooter extends React.Component {
    getFormatedValueGeneral() {
        const { immMyWalletCharts } = this.props;
        const consolidatedValueGeneral = immMyWalletCharts ? immMyWalletCharts.get('consolidatedValueGeneral') : false;
        const amount = consolidatedValueGeneral ? consolidatedValueGeneral.get('amount') : null;
        const currency = consolidatedValueGeneral ? consolidatedValueGeneral.get('currency') : null;

        if (amount == null || currency == null) {
            return <FormattedText value="broker-myInvestmentsNotAvailableInitials" />;
        }
        const actualValueGeneral = formatWithoutRound(amount, 2);
        const actualValueCurrencyGeneral = formatCurrency(currency);
        return `${actualValueGeneral} ${actualValueCurrencyGeneral}`;
    }

    buildActualValueSection() {
        const { totalValue, currency } = this.props;

        if (totalValue === null || currency === null) {
            return <FormattedText value="broker-myInvestmentsNotAvailableInitials" />;
        }

        const actualValue = formatWithoutRound(totalValue, 2);
        const actualValueCurrency = formatCurrency(currency);
        const actualValueFormatted = `${actualValue} ${actualValueCurrency}`;

        return <span>{actualValueFormatted}</span>;
    }

    buildCapitalSection() {
        const { totalCapital, totalRentability } = this.props;
        let capitalLabel;

        if (totalCapital === null || totalRentability === null) {
            capitalLabel = <FormattedText value="broker-myInvestmentsNotAvailableInitials" />;
        } else {
            const capital = formatWithoutRound(totalCapital, 2);
            const capitalCurrency = formatCurrency(this.props.currency);
            const capitalFormatted = `${capital} ${capitalCurrency}`;

            capitalLabel = <span>{capitalFormatted}</span>;
        }

        return (
            <span className="broker-my-investments-footer__totals col-xs-4">
                <FormattedText value="broker-myInvestmentsFooterCapitalInvertido" />
                <div className="broker-my-investments-footer__totals-value broker-my-investments-footer__totals-investment-value">
                    {capitalLabel}
                </div>
            </span>
        );
    }

    buildProfitability(value, currency, percentage) {
        return (
            <div>
                <span className="broker-my-investments-footer__earnings-value-currency">
                    <span className="broker-my-investments-footer__earnings-value">{value}</span>
                    <span className="broker-my-investments-footer__earnings-currency">{currency}</span>
                    <span className="broker-my-investments-footer__earnings-separator">|</span>
                </span>
                <span className="broker-my-investments-footer__earnings-percentage">{percentage}%</span>
            </div>
        )
    }

    buildRentabilitySection() {
        const { totalRentability, totalCapital, totalRentabilityPercentage, isContractFooter, currency } = this.props;
        let totalRentabilityLabel;

        if (totalRentability === null || totalCapital === null || currency === null) {
            totalRentabilityLabel = <FormattedText value="broker-myInvestmentsNotAvailableInitials" />;
        } else {
            const profitability = formatWithoutRound(totalRentability, 2);
            const profitabilityCurrency = formatCurrency(currency);
            const profitabilityPercentage = formatWithoutRound(totalRentabilityPercentage, 2);

            totalRentabilityLabel = this.buildProfitability(profitability, profitabilityCurrency, profitabilityPercentage);
        }

        const rentabilityClass = classNames({
            'broker-my-investments-footer__totals-rentability-product': !isContractFooter,
            'broker-my-investments-footer__totals-rentability-contract': isContractFooter,
        });

        return (
            <span className={rentabilityClass + " col-xs-4"}>
                <FormattedText value="broker-myInvestmentsFooterRentabilidad" />
                <div className="broker-my-investments-footer__totals-value broker-my-investments-footer__totals-profitability-value">
                    {totalRentabilityLabel}
                </div>
            </span>
        );
    }

    render() {
        const { isContractFooter, immMyWalletCharts } = this.props;
        const capitalSection = this.buildCapitalSection();
        const rentabilitySection = this.buildRentabilitySection();
        const actualValueSection = this.buildActualValueSection();
        const viewNotAvailable = formatText('broker-customViewsDropdownNotAvailableViewName');
        const isCustomWalletSelected = immMyWalletCharts ? immMyWalletCharts.get('isCustomWalletSelected') : false;
        const totalsClass = classNames({
            'broker-my-investments-footer__totals-product broker-my-investments-footer__totals-product--last': !isContractFooter,
            'broker-my-investments-footer__totals-contract broker-my-investments-footer__totals-contract--last': isContractFooter,
        });
        const valuesSizeClass = classNames({
            'col-xs-7': !isContractFooter,
            'col-xs-6': isContractFooter,
        });
        let footerSecondTitle;
        let actualValueFormattedGeneral;
        let footerTitle = "broker-myInvestmentsFooterTitle";
        let viewName;
        let selectedView;

        if (immMyWalletCharts) {
            viewName = immMyWalletCharts.get('selectedView') ? immMyWalletCharts.get('selectedView') : viewNotAvailable;

        }
        selectedView = immMyWalletCharts ? viewName : BROKER_CUSTOM_CONFIG_WALLET_GENERAL_NAME;

        if (isCustomWalletSelected) {
            footerTitle = "broker-myInvestmentsFooterTitleCustomView";
            footerSecondTitle = <FormattedText value="broker-myInvestmentsSecondFooterTitle" />
            actualValueFormattedGeneral = this.getFormatedValueGeneral();
            if (selectedView.length > MAX_LENGHT_OF_CUSTOM_VIEW_NAME) {
                selectedView = getFirstNChars(selectedView, MAX_LENGHT_OF_CUSTOM_VIEW_NAME);
            }
        }

        return (
            <div className="broker-my-investments-footer">
                <span className="broker-my-investments-footer__title col-xs-4">
                    <FormattedText value={footerTitle} injectedStrings={[selectedView]} />
                    <div className="broker-my-investments-footer__title-second-title">{footerSecondTitle}</div>
                </span>
                <div className={"broker-my-investments-footer__values row " + valuesSizeClass}>
                    {capitalSection}
                    {rentabilitySection}
                    <span className={totalsClass + " col-xs-3"}>
                        <FormattedText value="broker-myInvestmentsFooterValoracion" />
                        <div className="broker-my-investments-footer__totals-value broker-my-investments-footer__totals-current-value">{actualValueSection}</div>
                        {actualValueFormattedGeneral}
                    </span>
                </div>
            </div>
        );
    }
}

BrokerMyInvestmentsFooter.propTypes = {
    isContractFooter: PropTypes.bool,
    totalCapital: PropTypes.number,
    totalRentability: PropTypes.number,
    totalRentabilityPercentage: PropTypes.number,
    totalValue: PropTypes.number,
    currency: PropTypes.string,
    immMyWalletCharts: PropTypes.object,
    selectedViewName: PropTypes.string,
}

module.exports = BrokerMyInvestmentsFooter;
